import { navigate } from 'gatsby';
import logger from '../logger';

const scanToJoinTable = (urlString: string, queryTableStatus, paymentMode: boolean = true) => {
  const url = new URL(urlString);
  const urlParams = new URLSearchParams(url.search);

  const tableNumber = urlParams.get('tableNumber');
  const restaurantId = urlParams.get('restaurantId');

  if (!restaurantId || !tableNumber) {
    logger.info({
      msg: 'Unable to join via QR code. No restaurant or no table number provided in the URL',
      restaurantId,
      tableNumber,
    });
    navigate('/', { replace: true });
  }

  queryTableStatus(restaurantId, paymentMode, urlParams, false);
};

export default scanToJoinTable;
